import Vue from 'vue'
import Apexcharts from 'vue-apexcharts'

Vue.use(Apexcharts)

const isDark = window.localStorage.getItem('dark') === 'true'
const textColor = isDark ? 'white' : 'black'

// Default ApexCharts config
// https://github.com/apexcharts/vue-apexcharts/issues/105
window.Apex = {
  chart: {
    fontFamily: 'inherit',
    foreColor: textColor
  },
  theme: {
    palette: 'palette5'
  },
  tooltip: {
    theme: isDark ? 'dark' : 'light'
  },
  xaxis: {
    title: {
      style: {
        color: textColor,
        fontSize: '1.1rem',
        fontFamily: 'inherit'
      }
    },
    labels: {
      style: {
        colors: textColor
      }
    }
  },
  yaxis: {
    title: {
      style: {
        color: textColor,
        fontSize: '1.1rem',
        fontFamily: 'inherit'
      }
    },
    labels: {
      style: {
        color: textColor,
        fontFamily: 'inherit'
      }
    }
  }
}
